<h3>{{ 'user-profile.text.personal-data' | translate }}</h3>
<lib-base-card [isLoading]="isUpdatingPersonalData">
  <div class="card-content">
    <lib-personal-data-form
      [name]="user?.name"
      [surname]="user?.surname"
      [birthday]="user?.birthday"
      (personalDataChanged)="personalDataForm.setValue($event)"
    ></lib-personal-data-form>

    <lib-spacer></lib-spacer>

    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToUpdatePersonalData()"
      (click)="updatePersonalData()"
    >
      {{ 'user-profile.buttons.update' | translate }}
    </button>
  </div>
</lib-base-card>

<lib-spacer [height]="40"></lib-spacer>

<h3 [id]="CONTACT_INFO_SECTION_ID">
  {{ 'user-profile.text.contact-data' | translate }}
</h3>
<lib-base-card [isLoading]="isConfirmingContactData">
  <div class="card-content">
    <lib-contact-data-form
      [email]="user?.email"
      [phoneNr]="user?.phoneNr"
      [disableEmail]="user?.emailConfirmed"
      (contactDataChanged)="contactForm.setValue($event)"
    ></lib-contact-data-form>

    <lib-spacer></lib-spacer>

    <ng-container *ngIf="!user?.emailConfirmed">
      <div class="fit-content">
        <lib-info-box>
          <span>{{ 'user-profile.text.confirm-email' | translate }}</span>
        </lib-info-box>
      </div>

      <lib-spacer></lib-spacer>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!isAbleToConfirmEmail()"
        (click)="confirmEmail()"
      >
        {{ 'user-profile.buttons.confirm-email' | translate }}
        <ng-container *ngIf="resendPinCountdownInSecond > 0">
          ({{
            'user-profile.text.in-second'
              | translate : { seconds: resendPinCountdownInSecond }
          }})
        </ng-container>
      </button>

      <lib-spacer *ngIf="!user?.phoneNrConfirmed"></lib-spacer>
    </ng-container>

    <ng-container *ngIf="!user?.phoneNrConfirmed">
      <div class="fit-content">
        <lib-info-box>
          <span>{{ 'user-profile.text.confirm-phone-nr' | translate }}</span>
        </lib-info-box>
      </div>

      <lib-spacer></lib-spacer>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!isAbleToConfirmPhoneNumber()"
        (click)="confirmPhoneNumber()"
      >
        {{ 'user-profile.buttons.confirm-phone-nr' | translate }}
        <ng-container *ngIf="resendPinCountdownInSecond > 0">
          ({{
            'user-profile.text.in-second'
              | translate : { seconds: resendPinCountdownInSecond }
          }})
        </ng-container>
      </button>
    </ng-container>

    <ng-container *ngIf="user?.emailConfirmed && user?.phoneNrConfirmed">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!isAbleToConfirmPhoneNumber()"
        (click)="confirmPhoneNumber()"
      >
        {{ 'user-profile.buttons.update-phone-nr' | translate }}
        <ng-container *ngIf="resendPinCountdownInSecond > 0">
          ({{
            'user-profile.text.in-second'
              | translate : { seconds: resendPinCountdownInSecond }
          }})
        </ng-container>
      </button>
    </ng-container>
  </div>
</lib-base-card>

<lib-spacer [height]="40"></lib-spacer>

<h3>{{ 'user-profile.text.communication' | translate }}</h3>
<lib-base-card [isLoading]="isUpdatingCommunicationWayData">
  <div class="card-content">
    <div>
      {{ 'user-profile.text.communication-hint' | translate }}
    </div>
    <lib-spacer></lib-spacer>

    <mat-radio-group [formControl]="communicationWayForm">
      <mat-radio-button
        color="primary"
        style="margin-right: 30px"
        [value]="COMMUNICATION_WAY.EMAIL"
        >{{ 'user-profile.text.via-email' | translate }}</mat-radio-button
      >
      <mat-radio-button color="primary" [value]="COMMUNICATION_WAY.SMS">{{
        'user-profile.text.via-sms' | translate
      }}</mat-radio-button>
    </mat-radio-group>

    <lib-spacer></lib-spacer>

    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToUpdateCommunicationWay()"
      (click)="updateCommunicationWay()"
    >
      {{ 'user-profile.buttons.update' | translate }}
    </button>
  </div>
</lib-base-card>

<lib-spacer [height]="40"></lib-spacer>

<h3>{{ 'user-profile.text.password' | translate }}</h3>
<lib-base-card [isLoading]="isUpdatingPassword">
  <div class="card-content">
    <div>
      {{
        (!!user?.email
          ? 'user-profile.text.update-password-by-email'
          : 'user-profile.text.update-password-by-sms'
        ) | translate
      }}
    </div>
    <lib-spacer></lib-spacer>

    <lib-password-form [formControl]="passwordForm"></lib-password-form>

    <lib-spacer></lib-spacer>

    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToUpdatePassword()"
      (click)="requestUpdatePassword()"
    >
      {{ 'user-profile.buttons.update-password' | translate }}
      <ng-container *ngIf="resendPinCountdownInSecond > 0">
        ({{
          'user-profile.text.in-second'
            | translate : { seconds: resendPinCountdownInSecond }
        }})
      </ng-container>
    </button>
  </div>
</lib-base-card>

<ng-container *ngIf="showPinPassword">
  <lib-spacer [height]="40"></lib-spacer>
  <h3>{{ 'user-profile.text.pin-code' | translate }}</h3>
  <lib-base-card [isLoading]="isUpdatingPinCode">
    <div class="card-content">
      <div>
        {{
          'user-profile.text.pin-code-hint'
            | translate : { numberOfPinDigit: NUMBER_OF_PIN_DIGIT }
        }}
      </div>
      <lib-spacer></lib-spacer>

      <lib-pin-code-input [formControl]="updatePinForm"></lib-pin-code-input>

      <lib-spacer></lib-spacer>

      <button
        mat-flat-button
        color="primary"
        [disabled]="!isAbleToUpdatePin()"
        (click)="updatePIN()"
      >
        {{ 'user-profile.buttons.update' | translate }}
      </button>
    </div>
  </lib-base-card>
</ng-container>
